import React from "react";
import { Row, Col } from "react-bootstrap";
import SearchBar from "../../../components/searchbar/SearchBar";

const SubHeader = () => {
  return (
    <>
      <Row style={styles.divWhite}>
        <Col md={3}>
          <span style={styles.modify}>Last Modified By</span>
          <p style={styles.data}>Samir Bhor</p>
        </Col>
        <Col md={4}>
          <span style={styles.modify}> Modified on </span>
          <p style={styles.data}>27-3-2021</p>
        </Col>
        <Col md={5}>
          <SearchBar />
        </Col>
      </Row>
    </>
  );
};

const styles: any = {
  divWhite: {
    backgroundColor: "#fffff",
    paddingTop: "20px",
    paddingLeft: "20px",
    paddingRight: "20px",
  },

  modify: {
    fontSize: "12px",
    color: "#6d6e71",
    fontWeight: "400",
  },

  data: {
    fontFamily: "Saira",
    fontSize: "16px",
    fontWeight: "500",
    color: "black",
  },
};

export default SubHeader;
